import { FC, useEffect, useRef, useState } from 'react';
import 'swiper/css';
import 'swiper/css/grid';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Swiper as ISwiper } from 'swiper';
import { AVAILABLE_ARTICLES, IPropsArticle } from '../../../common/articles';
import './ArticlesAboutComponent.scss';
import { ARTICLES_DEFAULT_LABELS } from './model';

const ArticlesAboutComponent: FC = () => {
	const swiperRef = useRef<ISwiper>(null);
	const [width, setWidth] = useState(window.innerWidth);
	const [slidesPerView, setSlidesPerView] = useState(3);
	const [slidesPerGroup, setSlidesPerGroup] = useState(3);
	const [spaceBtw, setSpaceBtw] = useState(80);
	let swiperOptions = {
		modules: [Pagination],
		slidesPerView: slidesPerView,
		slidesPerGroup: slidesPerGroup,
		spaceBetween: spaceBtw,
		pagination: {
			clickable: true,
			dynamicBullets: true,
			dynamicMainBullets: 2
		},
		observeParents: true,
		onBeforeInit: (swiper: ISwiper) => {
			swiperRef.current = swiper;
		}
	};

	const handleClick = (article: IPropsArticle) => {
		window.open(`/article/${article.id}`);
	};

	useEffect(() => {
		const handleResize = () => setWidth(window.innerWidth);
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	useEffect(() => {
		if (width > 1440) {
			setSlidesPerView(3);
			setSlidesPerGroup(3);
		} else if (width > 1270 && width <= 1440) {
			setSlidesPerView(3);
			setSlidesPerGroup(3);
			setSpaceBtw(40);
		} else if (width > 957 && width <= 1270) {
			setSlidesPerView(3);
			setSlidesPerGroup(3);
			setSpaceBtw(120);
		} else if (width > 744 && width <= 957) {
			setSlidesPerView(3);
			setSlidesPerGroup(3);
			setSpaceBtw(160);
		} else if (width > 600 && width <= 743) {
			setSlidesPerView(3);
			setSlidesPerGroup(3);
			setSpaceBtw(10);
		} else if (width > 450 && width <= 599) {
			setSlidesPerView(2);
			setSlidesPerGroup(2);
			setSpaceBtw(10);
		} else if (width > 0 && width <= 444) {
			setSlidesPerView(2);
			setSlidesPerGroup(1);
			setSpaceBtw(10);
		}
	}, [width]);

	return (
		<div className='articles-container'>
			<h1 className='section-title'>{ARTICLES_DEFAULT_LABELS.title}</h1>
			<div className='carousel-articles-container'>
				<Swiper {...swiperOptions}>
					{AVAILABLE_ARTICLES.map((article: IPropsArticle, index: number) => (
						<SwiperSlide key={index}>
							<div className='article-card ' onClick={() => handleClick(article)}>
								<img
									src={article.coverImage}
									alt=''
									className={`a ${article.isContain ? 'makeContain' : ''} ${
										article.isFill ? 'makeFill' : ''
									}`}
								/>
								<div className='title'>{article.title}</div>
								<div className='date'>{article.date}</div>
							</div>
						</SwiperSlide>
					))}
				</Swiper>
			</div>
		</div>
	);
};

export default ArticlesAboutComponent;
